export default {
  data: function () {
    return {
      CONTACT_US: "mailto:support@eyedock.com",
      AMEMBER_SIGNUP: "https://www.eyedock.com/amember/logout",
      AMEMBER_MEMBER: "https://www.eyedock.com/amember/logout",
      CL_IMAGE_DIR:
        "https://www.eyedock.com/modules/Lenses/pnimages/lens_images",
      CL_COMPANY_LOGO_URL:
        "https://www.eyedock.com/modules/Lenses/pnimages/comp_logos",
      CL_TYPE_DIR: "https://www.eyedock.com/images/icons/lensTypes",
    };
  },
};
